import React, { useState, useEffect } from 'react';
import { useIsMobile } from '@/hooks/use-is-mobile';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const MobileAlert = () => {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);
  const [hasAccepted, setHasAccepted] = useState(false);

  useEffect(() => {
    // Check if user has previously accepted
    const hasUserAccepted = localStorage.getItem('mobileAlertAccepted') === 'true';
    setHasAccepted(hasUserAccepted);
    
    // Show alert only on mobile and if not previously accepted
    if (isMobile && !hasUserAccepted) {
      setOpen(true);
    }
  }, [isMobile]);

  const handleAccept = () => {
    localStorage.setItem('mobileAlertAccepted', 'true');
    setHasAccepted(true);
    setOpen(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Advertencia de dispositivo móvil</AlertDialogTitle>
          <AlertDialogDescription>
            No recomendamos el uso de FocusFlow en dispositivos móviles. ¿Seguro que quieres continuar?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            <a href="https://www.revenuehublatam.com">Salir</a>
          </AlertDialogCancel>
          <AlertDialogAction onClick={handleAccept}>
            Continuar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
